// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';

import firebase from 'firebase/compat/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyBITXbij9UH2mrUthpiFouQNntWC59regA',
  authDomain: 'enjoy-enter.firebaseapp.com',
  projectId: 'enjoy-enter',
  storageBucket: 'enjoy-enter.appspot.com',
  messagingSenderId: '541539243815',
  appId: '1:541539243815:web:4388c72d6c3661c79f3b02',
  measurementId: 'G-82PD15JQPM',
};

// Initialize Firebase

// firebaseConfig 정보로 firebase 시작
firebase.initializeApp(firebaseConfig);

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

export const firebaseInstance = firebase;
// firebase의 firestore 인스턴스를 변수에 저장
const firestore = firebase.firestore();

// 필요한 곳에서 사용할 수 있도록 내보내기
export { firestore };
